/**
 * returns HTML encoded characters as string
 */
export default function parseHTMLStrings(word: string) {
    const parser = new DOMParser()

    return parser.parseFromString(word, "text/html").documentElement.textContent
}